import { MsaViewer, type MsaViewerTab } from "@components/msa-viewer";
import { createFileRoute, Navigate, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { useViewerFile } from "./-viewerFileContext";

export const Route = createFileRoute("/_data/view/$fileId/heatmap")({
  component: HeatmapTab,
});

function HeatmapTab() {
  const file = useViewerFile();
  const navigate = useNavigate();

  const handleTabChange = useCallback(
    (tab: MsaViewerTab) => {
      if (tab === "alignment") {
        navigate({
          to: "/view/$fileId",
          params: { fileId: file.id },
          replace: true,
        });
      } else if (tab === "dotplot") {
        navigate({
          to: "/view/$fileId/dotplot",
          params: { fileId: file.id },
          replace: true,
        });
      }
    },
    [navigate, file.id],
  );

  if (file.type !== "GnomuxAlignment") {
    return <Navigate to="/view/$fileId" params={{ fileId: file.id }} replace />;
  }

  return <MsaViewer file={file} tab="heatmap" onTabChange={handleTabChange} />;
}
